import { Link } from 'gatsby'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

const Plan = ({
    title = "<span class='text-primary'>Hire </span> Development Team as per Your Need",
    description = "Exp. Senior Developers",
    sectionClass = "",
    maindes="Get a fully-signed NDA, top code security, easy exit policy, and simple transparent pricing with senior developers."
}) => {

    return (
        <>
            <div id='plan-section'></div>
            <section className={`section ${sectionClass}`}>
                <Container className="py-5">
                    <Row className="g-5" xs={1} lg={2}>
                        <Col lg={5}>
                            <div>
                                <h2 className="mb-3" dangerouslySetInnerHTML={{ __html: title }} />
                                <p className="lead mb-0">{maindes}</p>
                            </div>
                        </Col>
                        <Col lg={7}>
                            <div className='ps-lg-5 border border-3 border-top-0 border-bottom-0 border-end-0 d-flex flex-column equal-height'>
                                <h3 className="mb-3 fw-semibold">Monthly Plan</h3>
                                <p className="mb-4 lead fw-medium">Just $15/hour</p>
                                <Row as="ul" xs={1} md={2} className='check-list1 list-inline mb-4 g-3'>
                                    <Col as="li">160 Hours a month</Col>
                                    <Col as="li">8 Hours/day</Col>
                                    <Col as="li">5 Days/week</Col>
                                    <Col as="li">{description}</Col>
                                </Row>
                                <div className='mt-auto d-flex justify-content-between flex-wrap gap-3 border-top pt-4'>
                                    <div>
                                        <p className="mb-0 font-size-14">Starting from</p>
                                        <h4 className="mb-0 font-size-28 fw-semibold">$2400/mo</h4>
                                        <p className='mb-0 font-size-14 text-muted'>billed monthly</p>
                                    </div>
                                    <div className="text-center">
                                        <Link to="/request-quote.html" className="btn btn-primary-theme btn-lg">
                                            <span>Start free trial</span>
                                        </Link>
                                        <p className='fw-medium mt-2 mb-0'>14 days risk-free trial</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default Plan;
